import { render, staticRenderFns } from "./AI.vue?vue&type=template&id=40481d65&scoped=true"
import script from "./AI.vue?vue&type=script&lang=js"
export * from "./AI.vue?vue&type=script&lang=js"
import style0 from "./AI.vue?vue&type=style&index=0&id=40481d65&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40481d65",
  null
  
)

export default component.exports